import { GET_IS_CONNECTED, GET_RECONNECT_ERROR } from '@/system/store/getter-types'
import { CONNECT_WS } from '@/system/store/action-types'
import { CHOOSE_CUSTOMER_NAME, LOGIN_NAME } from '@/features/auth/auth.router'
import { IMiddlewareContext } from './middlewarePipeline'

import AuthService from '@/features/auth0/authService'

const routesWithoutWSConnection = [LOGIN_NAME]

const auth = new AuthService()

export const checkWsConnectionAndConnect = async ({ to, next, store }: IMiddlewareContext) => {
  const { name: destinationName } = to

  if (routesWithoutWSConnection.includes(destinationName as string)) return next()

  const isConnectedToWS = store.getters[GET_IS_CONNECTED]
  const isReconnectFailed = store.getters[GET_RECONNECT_ERROR]
  console.log('Connecting to websocket')

  if (!isConnectedToWS && !isReconnectFailed) {
    await store.dispatch(CONNECT_WS)
  }

  if (!isConnectedToWS && isReconnectFailed) {
    auth.logout()
  }

  return next()
}
